import React, { useState } from "react";
import Card from "../../MyUI/Card/Card";
import EditableForm from "../../MyUI/EditableForm/EditableForm";
import { validateRows } from "../../MyUI/EntityTableTemplate/validateEntity";
import { broadcast } from '../../../services/services';
import { Link, useNavigate, useParams } from "react-router-dom";

export default function SignUpPage() {

  const navigate = useNavigate();

  const formFields=[
    {key: "subject", label: "subject", type: "input", validation: ["required"] },
    {key: "message", label: "message", type: "textarea", placeholder: "Enter description...", validation: ["required"] },
  ];
  const [formParams, setFormParams] = useState([{}]);
  
  const idField = "id";
  const services= {
      create: broadcast,
      services_url_names: {
      create: "broadcast",
      },
    }
  
  return (
    <Card title={"Broadcast"} showChevron={false}>
       <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
        <h2 style={{marginBottom: "50px"}}>Broadcast</h2>
        {/* EditableForm rendered directly */}
        <EditableForm
          isNotScrollable={true}
          params={formParams}
          setParams={setFormParams}
          validateRows={validateRows}
          state="create"
          title={"Broadcast"}
          columns={formFields}
          services={services}       
          idField={idField}         
          refParam={null}   
          saveButtonName={"Broadcast"}
          onClose={() => {navigate("/Home");}}
          onSaved={(f) => {}}
        />

      </div>
    </Card>
  );
}
